// extracted by mini-css-extract-plugin
export default {"imgDiv":"error_imgDiv__MXwMa","errorImg":"error_errorImg__5gpTz","btnDiv":"error_btnDiv__B8GGX","errorBtn":"error_errorBtn__7YNf7"};